import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  CashiersListParams,
  CashiersListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CASHIERS_LIST_QUERY_KEY = 'cashiers_list';

export const useCashiersListQuery = (
  url: string,
  queryParams: CashiersListParams['queryParams'],
) =>
  useQuery({
    queryKey: [CASHIERS_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<CashiersListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
